import type { SupportedLocale } from "staticConfiguration";
import type { SelectOption } from "core/entities";
import { isSelectOption } from "core/utils/isSelectOption";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useAvailableLocales } from "./useAvailableLocales";

export function useLocaleName(locale: SupportedLocale) {
  const { t } = useTranslation("Fixhub", {
    keyPrefix: "Next:Core:LanguageCodes",
  });
  return t(locale);
}

export function useAvailableLocaleOptions(options?: {
  showLocaleCode?: boolean;
}) {
  const { availableLocales, data, isError, isLoading } = useAvailableLocales();
  const { t: tLocale } = useTranslation("Fixhub", {
    keyPrefix: "Next:Core:LanguageCodes",
  });

  const localeOptions = useMemo<SelectOption<SupportedLocale>[]>(
    () =>
      availableLocales
        .map((loc) => ({
          label: options?.showLocaleCode
            ? `${tLocale(loc)} (${loc})`
            : tLocale(loc),
          value: loc,
        }))
        .filter(isSelectOption),
    [availableLocales, options?.showLocaleCode, tLocale]
  );
  return { localeOptions, data, isError, isLoading, availableLocales };
}
